import Background from './components/Background'
import Hero from './components/Hero'
import WhyNearbies from './components/WhyNearbies'
import AppStory from './components/AppStory'
import DownloadApp from './components/DownloadApp'
import ForBusiness from './components/ForBusiness'
import Footer from './components/Footer'
import CookieConsent from './components/CookieConsent'
import PrivacyPolicy from './pages/PrivacyPolicy'
import TermsOfService from './pages/TermsOfService'
import CookiePolicy from './pages/CookiePolicy'
import Contact from './pages/Contact'

function App() {
  // Simple client-side routing based on URL path
  const path = window.location.pathname

  // Render legal pages
  if (path === '/privacy') {
    return <PrivacyPolicy />
  }

  if (path === '/terms') {
    return <TermsOfService />
  }

  if (path === '/cookies') {
    return <CookiePolicy />
  }

  if (path === '/contact' || path === '/delete-account') {
    return <Contact />
  }

  // Render home page
  return (
    <div className="relative min-h-screen">
      <Background />
      <Hero />
      <AppStory />
      <WhyNearbies />
      <DownloadApp />
      <ForBusiness />
      <Footer />
      <CookieConsent />
    </div>
  )
}

export default App
